import React from 'react';
import { CalculatorSection } from './Components/CalculatorSection';
import { ConsultantSection } from './Components/ConsultantSection';
import { FooterSection } from './Components/FooterSection';
import { HowItWorksSection } from './Components/HowItWorksSection';
import { InfoSection } from './Components/InfoSection';
import { Navbar } from './Components/Navbar';
import { SlowSection } from './Components/SlowSection';
import { StartSection } from './Components/StartSection';
import './WebflowCss/ark-payment.webflow.css';
import './WebflowCss/normalize.css';
import './WebflowCss/webflow.css';

function App() {
  return (
    <div>
      <Navbar />
      <StartSection />
      <SlowSection />
      <InfoSection />
      <HowItWorksSection />
      <ConsultantSection />
      <CalculatorSection />
      <FooterSection />
    </div>
  );
}

export default App;
